<template>
  <div class="document-uploader">
    <div v-if="mode == 'upload'">
      <div class="upload-text-detail">Upload a document</div>
      <documentUploader ref="documentUploader" :secure-upload-token="secureToken" :user-token="userToken"
        @uploadStarted="uploadStarted" @uploadSuccess="uploadSuccess" @uploadFailure="uploadFailure"
        @filesToUpload="getFilesForUpload" :isMobile="isMobile" />
      <div class="button-main">
        <v-btn width="150px" height="48px" color="#ffffff" class="upload-basic-btn cancel-btn" @click="goBack">
          Cancel
        </v-btn>
        <v-btn @click="startingUpload()" width="150px" height="48px" color="#128279" class="upload-basic-btn upload-btn"
          :disabled="uploadInProgress || !filesToUpload.length">
          Upload
        </v-btn>
      </div>
    </div>
    <v-snackbar v-if="snackbar" v-model="snackbar" color="#EAF4ED" elevation="50" :timeout="5000">
      <i class="fa-solid fa-circle-check" style="color: #32984d; font-size: 18px; margin-right: 20px" />
      Document(s) uploaded successfully
      <template v-slot:action="{ attrs }">
        <v-btn v-if="showSnackBtn" color="#32984D" v-bind="attrs" @click="handleDocsBtn">
          Go to Documents
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <v-snackbar v-if="isFail" v-model="isFail" color="#EAF4ED" elevation="50" :timeout="5000">
      <i class="fa-solid fa-xmark" style="color: #f50606; font-size: 18px; margin-right: 20px" />
      Unsupported file format or corrupted
    </v-snackbar> -->
    <SnackBar id="error-snack-bar" :snackbar="isFail" snackbarMsg="Unsupported file format or corrupted"
      iconName="fa-regular fa-xmark" :isSuccess="!isFail" />
  </div>
</template>

<script>
import documentUploader from './upload-document.vue'
import Utils from '../../utils/helpers'
import SnackBar from '../snack-bar.vue'

export default {
  name: 'DocumentUploaderModal',
  props: ['mode', 'onModalClose', 'startUpload', 'secureToken', 'userToken', 'userId'],
  components: {
    documentUploader,
    SnackBar
  },
  data() {
    return {
      uploadInProgress: false,
      snackbar: false,
      showSnackBtn: false,
      text: '',
      filesToUpload: [],
      isFail: false
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 562
    }
  },
  methods: {
    goBack() {
      const from = this.$route.query.from
      from && from == 'onboarding-upload'
        ? this.$router.push(`/${this.userId}/home`)
        : this.$router.go(-1)
    },
    startingUpload() {
      this.$refs.documentUploader.startUpload()
    },
    abortUpload() {
      this.$refs.documentUploader.abortUpload()
    },
    uploadStarted() {
      this.uploadInProgress = true
    },
    uploadSuccess() {
      this.snackbar = true
      this.uploadInProgress = false
      this.showSnackBtn = true
    },
    uploadFailure() {
      this.uploadInProgress = false
      this.showSnackBtn = false
      this.isFail = true
      setTimeout(() => {
        this.isFail = false
      }, 2000)
    },
    fileReadStart() {
      this.uploadInProgress = true
    },
    fileReadStop() {
      this.uploadInProgress = false
    },
    handleDocsBtn() {
      Utils.manageProfileRouting({
        path: 'records',
        route: this.$route,
        router: this.$router
      })
    },
    getFilesForUpload(files) {
      this.filesToUpload = files
    }
  }
}
</script>

<style>
.v-snack__content {
  color: #000000 !important;
  padding-right: 16px;
}
</style>

<style scoped>
.document-uploader {
  background-color: white;
  border-radius: 8px;
  max-width: 550px;
  margin: auto;
}

.uploadText {
  color: #185abc;
  padding-top: 8px;
}

.upload-text-detail {
  color: #161616;
  padding-bottom: 16px;
  font-size: 22px;
  text-align: center;
  font-weight: 600;
}

.button-main {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.label-cont {
  left: 0;
  right: 0;
  top: calc(50%);
  position: absolute;
  text-align: center;
  color: #d2d2d2;
  font-size: 14px;
  font-weight: bold;
  z-index: 0;
  opacity: 0.8;
}

.q-icon {
  font-size: 32px;
  margin-bottom: 5px;
}

.q-spinner {
  display: none;
}

.v-btn {
  text-transform: none !important;
}

.sent-successfully-header {
  font-size: 18px;
  font-weight: 600;
  color: #185abc;
  margin-bottom: 16px;
}

.sent-successfully-subtext {
  font-size: 14px;
  color: #696969;
}

.upload-basic-btn {
  font-weight: 700 !important;
  font-size: 16px !important;
  padding: 12px 18px !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

.cancel-btn {
  border: 2px solid #161616 !important;
  color: #161616 !important;
  background: #ffffff !important;
  margin-right: 24px !important;
}

.upload-btn {
  background: #128279;
  color: #ffffff !important;
}

/*@media only screen and (min-width: 800px) {
  .button-main {
    justify-content: flex-end;
  }
}*/
@media only screen and (max-width: 600px) {
  .document-uploader {
    padding: 0 16px;
  }

  .button-main {
    justify-content: space-between;
  }
}
</style>
